<template>
  <v-text-field
    @change="handleSetExternalCode"
    :value="value"
    :label="label"
    outlined
  />
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'ExternalCode',

  props: {
    value: {
      type: String,
      default: '',
    },

    label: {
      type: String,
    },

    rules: {
      type: Array,
    },
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleSetExternalCode(value) {
      this.setAppointmentFields({ external_code: value })
    },
  },
}
</script>
